import { createContext } from 'react';
const ContribuyenteContext = createContext(); 

export default ContribuyenteContext;